export const FilterType = {
  CUSTOMERS_NAME: 0,
  VISIT_ON: 2,
  CALL_WHATSAPP: 3,
  LAST_CONTACT: 4,
};